import React from "react";
import Logout from "../pages/Logout";
import { Redirect } from "react-router-dom";
import { URL_PATHS } from "../routes";
import { AppState } from "../store";
import { useSelector } from "react-redux";

const LogoutContainer = () => {
    const myUser = useSelector((state: AppState) => state.myData.user);

    if (!myUser) {
        return <Redirect to={URL_PATHS.login()} />;
    }
    return <Logout></Logout>;
};

export default LogoutContainer;
